import React from 'react';
import PropTypes from 'prop-types';
import AcceptTerms, { AcceptTermsWithInsurance } from 'components/shared/AcceptTerms';
import moment from 'logic/moment';

const AcceptanceTermsText = ({ booking }) => {
  const insurance = moment(booking.check_out).isAfter(moment('2021-02-28'), 'day')
    || moment(booking.created_at).isAfter(moment('2021-01-31'), 'day');

  if (insurance) {
    return (
      <AcceptTermsWithInsurance />
    );
  }

  return (
    <AcceptTerms withRentalTerms />
  );
};

AcceptanceTermsText.propTypes = {
  booking: PropTypes.shape({
    check_out: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    created_at: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
};

export default AcceptanceTermsText;
